// import { useQuery } from '@/utils/graphqlHooks';
import {
  useQuery
} from '@tanstack/react-query'
import { useMemo } from 'react';

import { useAppFlowContext } from '@/contexts/appFlow';
import { useLdFlags } from '@/contexts/ldFlags';
import { TranslationsCtx } from '@/contexts/translations';
import { GetI18nContentDocument } from '@/graphql/generated';
import { normalizeTranslations } from '@/utils/translation';
import {getI18nContent} from '../../service'


export const TranslationProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { langKey } = useAppFlowContext();
  const flags = useLdFlags() ?? {};
  const { appContentWithKeyNonProd } = flags;

/*   const {
    loading,
    data: i18nResp,
    error,
  } = useQuery("getI18nContent", getI18nContent(),{
    variables: {
      langKey,
    },
  }); */


  const { 
  data: i18nResp,     // 把 data 重命名为 i18nResp
  isLoading,          // 推荐使用 isLoading（比 loading 更准确）
  error 
}  = useQuery<any>({ queryKey: ['i18n', { langKey }], queryFn: () => getI18nContent({
    variables: {
      langKey,
    }
  }), })




  const translations = useMemo(
    () =>
      normalizeTranslations({
        i18nContentLabel: i18nResp?.getI18nContent?.i18nContentLabel,
        i18nContentImage: i18nResp?.getI18nContent?.i18nContentImage,
        appContentWithKeyNonProd,
      }),
    [
      i18nResp?.getI18nContent?.i18nContentLabel,
      i18nResp?.getI18nContent?.i18nContentImage,
      appContentWithKeyNonProd,
    ],
  );
  return (
    // @ts-ignore
    <TranslationsCtx.Provider value={{ content: translations, loading:isLoading, error }}>
      {children}
    </TranslationsCtx.Provider>
  );
};
